var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamatory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1514_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1514_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.36 -0.359985H-0.360001V16.36H16.36V-0.359985Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1514_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 15.49C3.86999 15.49 0.509995 12.13 0.509995 8.00001C0.509995 3.87001 3.86999 0.51001 7.99999 0.51001C12.13 0.51001 15.49 3.87001 15.49 8.00001C15.49 12.13 12.13 15.49 7.99999 15.49ZM7.99999 1.56001C4.44999 1.56001 1.55999 4.45001 1.55999 8.00001C1.55999 11.55 4.44999 14.44 7.99999 14.44C11.55 14.44 14.44 11.55 14.44 8.00001C14.44 4.45001 11.55 1.56001 7.99999 1.56001Z",
    fill: "#FF0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.21995C7.71 9.21995 7.48 8.97995 7.48 8.69995V5.21995C7.48 4.92995 7.72 4.69995 8 4.69995C8.28 4.69995 8.52 4.93995 8.52 5.21995V8.69995C8.52 8.98995 8.28 9.21995 8 9.21995Z",
    fill: "#FF0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 11.48C7.90999 11.48 7.81999 11.46 7.73999 11.42C7.65999 11.39 7.57999 11.34 7.50999 11.27C7.44999 11.2 7.39999 11.13 7.35999 11.04C7.32999 10.96 7.29999 10.87 7.29999 10.78C7.29999 10.69 7.31999 10.6 7.35999 10.52C7.38999 10.44 7.43999 10.36 7.50999 10.29C7.57999 10.23 7.65999 10.18 7.73999 10.14C7.90999 10.07 8.09999 10.07 8.26999 10.14C8.34999 10.17 8.42999 10.22 8.49999 10.29C8.55999 10.36 8.60999 10.44 8.64999 10.52C8.67999 10.6 8.70999 10.69 8.70999 10.78C8.70999 10.87 8.68999 10.96 8.64999 11.04C8.61999 11.13 8.56999 11.2 8.49999 11.27C8.42999 11.33 8.34999 11.38 8.26999 11.42C8.18999 11.45 8.09999 11.48 8.00999 11.48H7.99999Z",
    fill: "#FF0033"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1514_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamatory);
export default __webpack_public_path__ + "static/media/exclamatory.401f47ab69ae317256105a70c9a11897.svg";
export { ForwardRef as ReactComponent };